<app-files-listing-general
    *ngIf="authUser | async; else loading"
    [fixedFilters]="tableFilterItems"
    visibility="academy"
    class="scorm-manager-files"
    #filesList
></app-files-listing-general>
<ng-template #loading>
    <div fxFlex="0 0 100%" fxLayout="row" fxLayoutAlign="center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
